import React, { useState, useEffect, useRef } from "react";
import {
  Select,
  message,
  Image as AntImage,
  Card,
  List,
  Input,
  Modal,
  Button,
  Layout,
  Descriptions,
  Typography,
} from "antd";
import Aguarde from "../../../components/aguarde/aguarde";
import { FaEdit, FaPlus, FaRegClipboard, FaTrash } from "react-icons/fa";
import { Content } from "antd/es/layout/layout";
import DrawerImages from "../../../components/ui/Drawer/DrawerImages";
import { request } from "../../../functions/request";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { editoriaOpcoes } from "../../../constants/constants";
const { Search } = Input;
const { Meta } = Card;

export default function Imagens() {
  const [imagensData, setImagensData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [drawer, setDrawer] = useState({
    isOpen: false,
    data: null,
    shouldRefreshToggle: false,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState("");
  const [URLSearchParams, SetURLSearchParams] = useSearchParams();
  const [search, setSearch] = useState({
    filter: "",
    textSearchType: "img_comentario",
  });
  const pageSize =
    parseInt(URLSearchParams.get("pageSize")) ||
    parseInt(localStorage.getItem("pageSize")) ||
    10;
  const ref = useRef(null);

  useEffect(() => {
    async function getData() {
      setIsLoading(true);
      const currentPathWithQuery = `/imagem/getLastImagens`;
      const response = await request(currentPathWithQuery, {
        method: "GET",
      }).catch(() => {
        setIsLoading(false);
      });
      setImagensData(response);
      setIsLoading(false);
    }
    getData();
  }, [drawer.shouldRefreshToggle]);

  const onSearch = async (value) => {
    let currentPathWithQuery = `/imagem/getImagemWithFilter?`;

    if (value === "" && search.filter === "") {
      currentPathWithQuery = `/imagem/getLastImagens`;
    } else {
      // Filtra pela coluna img_editoria (indexada). Antes isso era feito por
      // prefixo do nome do arquivo (img_arquivo LIKE 'gf01%'), que varria as
      // 378 mil linhas e ignorava reclassificações feitas depois do upload.
      currentPathWithQuery += `img_nome=${
        search.textSearchType === "img_nome" ? value : ""
      }&img_comentario=${
        search.textSearchType === "img_comentario" ? value : ""
      }&img_editoria=${search.filter}`;
    }

    setIsLoading(true);
    await request(currentPathWithQuery, {
      method: "GET",
    })
      .then((response) => {
        setImagensData(response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedItem("");
  };

  const handleDelete = async () => {
    const query = `/imagem/deleteImagem?img_codigo=${selectedItem.img_codigo}&img_arquivo=${selectedItem.img_arquivo}`;

    try {
      request(query, { method: "DELETE" });
      message.success("Imagem apagada com sucesso!");
      handleCancel();
      const newImagensData = imagensData.filter(
        (item) => item.img_codigo !== selectedItem.img_codigo
      );
      setImagensData(newImagensData);
    } catch (error) {
      console.error("Error during delete:", error);
      message.error("Erro ao apagar a imagem.");
    }
  };

  const pesquisaOpcoes = [
    { value: "img_nome", label: "Legenda" },
    { value: "img_comentario", label: "Comentário" },
  ];

  const handleCopyText = (item) => {
    console.log(item);
    try {
      navigator.clipboard.writeText(
        `${process.env.REACT_APP_BANCO_IMG_URL}${item.img_arquivo}`
      );
      message.success("Link copiado para a área de transferência!");
    } catch (err) {
      message.error("Não foi possível concluir a ação!");
      console.log(err);
    }
  };

  function scrollTop() {
    return ref.current?.scrollTo(0, 0);
  }

  return (
    <Layout
      style={{
        width: "100%",
        paddingBottom: "10px",
        maxHeight: "100%",
        overflowY: "auto",
        padding: 10,
        display: "flex",
        flexDirection: "column",
      }}
      ref={ref}
    >
      <DrawerImages
        open={drawer.isOpen}
        onClose={() =>
          setDrawer((prevState) => ({ ...prevState, isOpen: false }))
        }
        data={drawer.data}
        setDrawer={setDrawer}
      />
      <Descriptions
        title="Banco de Imagens"
        layout="vertical"
        extra={
          <Content style={{ display: "flex", gap: 30 }}>
            <Content style={{ display: "flex", gap: 10 }}>
              <Select
                title="Filtro"
                placeholder={"Filtrar por editoria"}
                options={editoriaOpcoes}
                allowClear
                onSelect={(value) =>
                  setSearch((prevState) => ({
                    ...prevState,
                    filter: value,
                  }))
                }
                onClear={() =>
                  setSearch((prevState) => ({
                    ...prevState,
                    filter: "",
                  }))
                }
              />
              <Search
                placeholder="Pesquisar..."
                onSearch={(value) => {
                  onSearch(value);
                  scrollTop();
                }}
                addonBefore={
                  <Select
                    defaultValue="img_comentario"
                    options={pesquisaOpcoes}
                    onSelect={(value) =>
                      setSearch((prevState) => ({
                        ...prevState,
                        textSearchType: value,
                      }))
                    }
                    onClear={() =>
                      setSearch((prevState) => ({
                        ...prevState,
                        textSearchType: "",
                      }))
                    }
                  />
                }
              />
            </Content>
            <Button
              type="primary"
              icon={<FaPlus size={16} />}
              size="large"
              onClick={() =>
                setDrawer((prevState) => ({
                  ...prevState,
                  data: null,
                  isOpen: true,
                }))
              }
            >
              Inserir Nova Imagem
            </Button>
          </Content>
        }
        style={{ paddingInline: 12 }}
      ></Descriptions>

      {isLoading ? (
        <Aguarde />
      ) : (
        <List
          grid={{
            gutter: 16,
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 4,
            xxl: 4,
          }}
          dataSource={imagensData}
          pagination={{
            position: "both",
            align: "start",
            pageSize: pageSize,
            current: parseInt(URLSearchParams.get("page")) || undefined,
            onChange: (page, pageSize) => {
              if (pageSize) {
                localStorage.setItem("pageSize", pageSize.toString());
              }
              SetURLSearchParams({ pageSize: pageSize, page: page });
              scrollTop();
            },
          }}
          style={{ padding: "20px 10px" }}
          renderItem={(item) => (
            <List.Item style={{ padding: "20px 0" }}>
              <Card
                hoverable
                id={item.img_codigo}
                style={{ width: "100%", margin: "auto", height: "100%" }}
                cover={
                  <AntImage
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src={`${process.env.REACT_APP_BANCO_IMG_URL}${item.img_arquivo}`}
                    fallback={fallback}
                  />
                }
                actions={[
                  <FaRegClipboard
                    key={"copy"}
                    onClick={() => handleCopyText(item)}
                    title="Clique para copiar o endereço da imagem"
                  />,
                  <FaEdit
                    key="edit"
                    onClick={() => {
                      setDrawer((prevState) => ({
                        ...prevState,
                        data: item,
                        isOpen: true,
                      }));
                    }}
                  />,
                  <FaTrash
                    title="Excluir"
                    key="delete"
                    onClick={() => {
                      setIsModalVisible(true);
                      setSelectedItem(item);
                    }}
                    style={{ color: "red" }}
                  />,
                ]}
              >
                <Content
                  onClick={() => {
                    setDrawer((prevState) => ({
                      ...prevState,
                      data: item,
                      isOpen: true,
                    }));
                  }}
                >
                  <Meta
                    title={item.img_nome}
                    description={item.img_comentario}
                  />
                  <Typography style={{ marginTop: "16px", fontWeight: 600 }}>
                    {moment(item.img_data).format("DD/MM/YYYY [às] HH:mm")}
                  </Typography>
                </Content>
              </Card>
            </List.Item>
          )}
        />
      )}

      <Modal
        item={selectedItem}
        title="Apagar imagem"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button key="excluir" type="primary" onClick={handleDelete}>
            Excluir
          </Button>,
        ]}
      >
        <p>
          Deseja realmente apagar essa imagem (Código: {selectedItem.img_codigo}
          )?
        </p>
      </Modal>
    </Layout>
  );
}
//imagem de fallback em base64
const fallback =
  "data:image/png;base64,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";
